import Vue from 'vue'
import axios from './vue-axios/axios'

export function getReplacementMotives() {
  return Vue.axios.get(process.env.API_URL + '/v1/replacement_motives')
}



// WEBPACK FOOTER //
// ./src/backend/replacementMotives.js